import React from 'react';
import { UiKit } from '@datavant/idsb-shared/uikit';

export const DigitalFulfillmentLogo = (): JSX.Element => {
    return (
        <UiKit.Chakra.HStack>
            <svg xmlns="http://www.w3.org/2000/svg" width="125" height="125">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="125"
                    height="125"
                    viewBox="0 0 125 125"
                    fill="none"
                >
                    <circle cx="62.5" cy="62.5" r="50" fill="#D2FFF4" />
                </svg>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="75"
                    height="75"
                    viewBox="0 0 75 75"
                    y="25"
                    x="25"
                    fill="none"
                >
                    <path
                        // eslint-disable-next-line max-len
                        d="M30.0005 45.5469L33.9129 37.0374L42.4224 33.125L33.9129 29.2126L30.0005 20.7031L26.0881 29.2126L17.5786 33.125L26.0881 37.0374L30.0005 45.5469ZM30.0005 56.875L22.5786 40.5469L6.25049 33.125L22.5786 25.7031L30.0005 9.375L37.4224 25.7031L53.7505 33.125L37.4224 40.5469L30.0005 56.875ZM56.8755 65.625L53.2036 57.4219L45.0005 53.75L53.2036 50L56.8755 41.875L60.6255 50L68.7505 53.75L60.6255 57.4219L56.8755 65.625Z"
                        fill="#0FD9B8"
                    />
                </svg>
            </svg>
        </UiKit.Chakra.HStack>
    );
};
